export const CURRENCIES = ["EUR", "CHF", "USD", "GBP"];

export const UNSUPPORTED_IMG_MSG =
  "Bild konnte nicht ausgelesen werden, da es sich um ein nicht zulässiges Dateiformat handelt. Zugelassen sind JPG, PNG, HEIC und PDF. Sie können dennoch fortfahren und die Parameter manuell eintragen.";

export const EMPTY_FORM = {
  supplier: "",
  invoice_number: "",
  date: "",
  price: "",
  vat_amount: "",
  vat_rate: "",
  vat_breakdown: [],
  currency: "EUR",
  tip: "",
  purpose: "",
  purpose_other: "",
  performed_by: "",
  performed_by_other: "",
  paid_by: "",
  paid_by_other: "",
  paid_with: "",
  paid_with_other: "",
  note: "",
};

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Format a numeric value to a fixed 2-decimal string for money inputs.
export const to2 = (v) => {
  if (v === "" || v === null || v === undefined) return "";
  const n = Number(v);
  return Number.isNaN(n) ? v : n.toFixed(2);
};
